/**
 * @ticket TM-1000001960
 * NgModule for the au (Auth Administration) module.
 * Config-only module: declares the AuConfigPage and registers the au entity provider.
 */
import {NgModule, Type} from '@angular/core';
import {AuConfigPage} from "./page/overview/config/au-config.page";
import {AU_ENTITY_PROVIDER} from "./au.entity-provider";
import {CoreModule} from "../../core/core.module";
import {UiModule} from "../../core/ui/ui.module";
import {DynamicModule} from "../../core/shared/interface/dynamic-module.interface";
import {ModuleRegistryService} from "../../core/shared/interface/module-registration.service";
import {KpiComponentInterface} from "../../core/shared/interface/kpi-component.interface";
import {StatisticsComponentInterface} from "../../core/shared/interface/statistics-component.interface";

@NgModule({
    declarations: [
        AuConfigPage
    ],
    exports: [
        AuConfigPage
    ],
    imports: [
        CoreModule,
        UiModule
    ],
    providers: [
        AU_ENTITY_PROVIDER
    ]
})
export class AuModule implements DynamicModule {

    alias = 'au';

    constructor(private moduleRegistry: ModuleRegistryService) {
        this.moduleRegistry.registerModule(this);
    }

    getKpiComponent(): Type<KpiComponentInterface> {
        return null;
    }

    getStatisticsComponent(): Type<StatisticsComponentInterface> {
        return null;
    }
}
